import {Component, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioboxModel } from '../radiobox.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';

@Component({
    selector: 'abw-radiobox-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RadioboxFormComponent),
        multi: true
      }
    ],
    templateUrl: './radiobox-form.component.html',
    styleUrls: ['./radiobox-form.component.scss']
})
export class RadioboxFormComponent extends AbstractWorkflowFormComponent<RadioboxModel, string> {
}